import styled, {css} from 'styled-components';
import {Link} from 'react-router-dom';
import {getObjectProp} from '../utils/helpers/object';

const activeStyles = css`
  ${({active, theme}) => css`
    ${active === 1 &&
    css`
      color: ${getObjectProp(theme, 'vars.palette.primary.dark')};
    `}
  `}
`;

const baseStyles = css`
  ${({theme}) => css`
    text-decoration: none;
    color: ${getObjectProp(theme, 'vars.palette.primary.main')};
    transition: all 230ms ease-in-out;
    display: inline-flex;
    font-size: inherit;
  `};
`;

const hoverStyles = css`
  ${({theme}) => css`
    &:hover {
      color: ${theme.palette.primary.dark};
    }
  `}
`;

const StyledNavLink = styled(Link)`
  ${baseStyles}
  ${activeStyles}
  ${hoverStyles}
`;

export const StyledNavHyperlink = styled.a`
  ${baseStyles}
  ${activeStyles}
  ${hoverStyles}
`;

export default StyledNavLink;
